"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ADDRESS_SEARCH_INPUT_ID = void 0;
var _AddressSearchInput = _interopRequireDefault(require("../../components/address-search-input/AddressSearchInput"));
var _restrictInput = require("../normalizers/restrictInput");
var _regex = _interopRequireWildcard(require("../regex"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ADDRESS_SEARCH_INPUT_ID = exports.ADDRESS_SEARCH_INPUT_ID = 'address-search-input';
var ADDRESS_SEARCH = {
  component: _AddressSearchInput["default"],
  id: ADDRESS_SEARCH_INPUT_ID,
  name: ADDRESS_SEARCH_INPUT_ID,
  label: 'Start typing your address or postcode',
  required: true,
  className: 'fieldLarge',
  regex: (0, _regex["default"])(_regex.asciiExtendedPattern),
  validationMessageKeys: {
    required: 'Please enter an address'
  },
  normalize: _restrictInput.asciiExtendedOnly
};
var _default = exports["default"] = ADDRESS_SEARCH;